import PresentationApi from '@/api/presentation'

const actions = {
  getPresentationDetailsByShareCodeAction: async ({ dispatch }, { shareCode, presentationId, payloadDataPresentation }) => {
    const [res] = await Promise.all([
      PresentationApi.getPresentationDetailsByShareCode(shareCode, payloadDataPresentation),
      dispatch('presentationAttributeModule/getPresentationAttributeAction', presentationId, { root: true }),
      dispatch('featureToggles/handlePresentationLoadFlagUnleashByShareCode', shareCode, { root: true }),
    ])
    return res
  },
}

export default {
  namespaced: true,
  actions,
}
